import React, { useState } from 'react';
import { PinterestBoardView, PinterestBoardViewProps } from './PinterestBoard.view';
import { CorePinterestBoardFieldsFragment, useRefreshPinterestBoardsMutation } from '../../../models/graphql';
import { triggerErrorToast } from '../../../helpers/triggerErrorToast';
import { SocialProfileComponentExtendedType } from '../SocialProfile/SocialProfile.view';
import { SelectItem } from '../../forms/Select/Select.view';
import { TikTokSettingsViewProps } from '../TikTokSettings/TikTokSettings.view';

export type PinterestBoardControllerProps = {
  socialProfile: SocialProfileComponentExtendedType;
  useFormInstance: PinterestBoardViewProps['useFormInstance'];
  pinterestBoardValue?: PinterestBoardViewProps['pinterestBoardValue'];
  pinterestFormName: PinterestBoardViewProps['pinterestFormName'];
  pinterestRules: PinterestBoardViewProps['pinterestRules'];
  parentDropdownRef?: PinterestBoardViewProps['parentDropdownRef'];
  isParentDropdownExpanded: TikTokSettingsViewProps['isParentDropdownExpanded'];
  // extend your PinterestBoardViewProps
};

const mapPnBoards = (pinterestBoards?: CorePinterestBoardFieldsFragment[]) =>
  pinterestBoards?.map<SelectItem>(board => ({
    label: board.name,
    value: board.externalId
  })) || [];

export const PinterestBoardController = (props: PinterestBoardControllerProps): JSX.Element => {
  // Put All your methods and logic here
  const {
    socialProfile: { id }
  } = props;
  const [refreshPnBoardsMutation] = useRefreshPinterestBoardsMutation();
  const [loading, setLoading] = useState<boolean>(false);
  const [selectItems, setSelectItems] = useState<SelectItem[]>(mapPnBoards(props.socialProfile.pinterestBoards));
  const refreshPnBoards = () => {
    setLoading(true);
    refreshPnBoardsMutation({ variables: { id }, fetchPolicy: 'no-cache' })
      .then(result => {
        setLoading(false);
        setSelectItems(old => {
          const oldStringified = JSON.stringify(old);
          const newItems = mapPnBoards(result.data?.refreshPinterestBoards.boards);
          const newStringified = JSON.stringify(newItems);
          return oldStringified === newStringified ? old : newItems;
        });
      })
      .catch(e => {
        triggerErrorToast('Refreshing Pinterest Boards Failed')(e);
        setLoading(false);
      });
  };

  const viewProps: PinterestBoardViewProps = {
    ...props,
    refreshPnBoards,
    loading,
    selectItems,
    profile: props.socialProfile
  };
  return <PinterestBoardView {...viewProps} />;
};
